import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
var id = 0;

var genId = function genId() {
  id += 1;
  return "genId-".concat(id);
};

var useId = function useId(externallyProvidedId) {
  var _useState = useState(function () {
    return externallyProvidedId || genId();
  }),
      _useState2 = _slicedToArray(_useState, 1),
      uniqueId = _useState2[0];

  return uniqueId;
};

export default useId;